export default "__VITE_ASSET__EXi9qLGQ__"